import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { STRINGS } from "../Strings";

import bannerElder from '../assets/elders.jpg';
import bannerDisabled from '../assets/disabled.jpg';
import bannerYouth from '../assets/youth.jpg';
import bannerOrphans from '../assets/orphans.jpg';
import bannerPoor from '../assets/poor.jpg';
import bannerHomeless from '../assets/homeless.jpg';
import bannerAddicts from '../assets/addicts.jpg';
import bannerPrisoners from '../assets/prisoners.jpg';

export default function HomeBanner(props) {
    const appContext = useContext(AppContext);
    const language = appContext.language || "en";
    const s = STRINGS.homeBanner;

    const [ready, setReady] = useState(false);
    const [bgIndex, setBgIndex] = useState(0);

    const banners = [
        { img: bannerElder, key: "elder" },
        { img: bannerDisabled, key: "disabled" },
        { img: bannerYouth, key: "youth" },
        { img: bannerOrphans, key: "orphans" },
        { img: bannerPoor, key: "poor" },
        { img: bannerHomeless, key: "homeless" },
        { img: bannerAddicts, key: "addicts" },
        { img: bannerPrisoners, key: "prisoners" }
    ];

    async function init() {
        setReady(false);
        // Initialization space
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    // Automatic transition every 5 seconds
    useEffect(() => {
        if (!ready) return;
        const interval = setInterval(() => {
            handleNext();
        }, 5000);
        return () => clearInterval(interval);
    }, [ready, bgIndex]);

    const handleNext = () => {
        setBgIndex((prev) => (prev + 1) % banners.length);
    };

    const handlePrev = () => {
        setBgIndex((prev) => (prev - 1 + banners.length) % banners.length);
    };

    if (ready) {
        return (
            <div className="MainBodySection position-relative overflow-hidden hero-banner-viewport">
                {/* Background Slider */}
                {banners.map((item, i) => (
                    <div
                        key={i}
                        className="hero-slide-bg"
                        style={{
                            backgroundImage: `url(${item.img})`,
                            opacity: i === bgIndex ? 1 : 0,
                            zIndex: i === bgIndex ? 1 : 0,
                        }}
                    />
                ))}

                {/* Main Dark Gradient Overlay */}
                <div className="hero-overlay d-flex align-items-center">
                    <div className="container position-relative">
                        <div className="row justify-content-center text-center">
                            <div className="col-12 col-md-10 col-lg-8 px-4">
                                
                                {/* Target Group Tag */}
                                <span className="hero-badge font-semi-bold text-uppercase mb-3 d-inline-block">
                                    {s[banners[bgIndex].key].tag[language]}
                                </span>

                                {/* Clean minimal main heading */}
                                <h1 className="title-font-bold text-light hero-main-title mb-3">
                                    {s[banners[bgIndex].key].title[language]}
                                </h1>

                                {/* Supportive descriptive text */}
                                <p className="font-light text-light hero-sub-title mb-5">
                                    {s[banners[bgIndex].key].subtitle[language]}
                                </p>

                                {/* Action Buttons */}
                                <div className="d-flex flex-wrap justify-content-center gap-3">
                                    <button
                                        className="btn btn-hero-primary title-font-semi-bold"
                                        onClick={() => appContext.navTo({ item: 'services' })}
                                    >
                                        {s.buttons.learnMore[language]}
                                    </button>
                                    <button
                                        className="btn btn-hero-outline title-font-semi-bold"
                                        onClick={() => appContext.navTo({ item: 'get_involved' })}
                                    >
                                        {s.buttons.support[language]}
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {/* Navigation Arrows */}
                <button className="hero-arrow arrow-left" onClick={handlePrev} aria-label="Previous Slide">
                    <FaArrowLeft size={22} />
                </button>
                <button className="hero-arrow arrow-right" onClick={handleNext} aria-label="Next Slide">
                    <FaArrowRight size={22} />
                </button>

                {/* Slider Indicators at the bottom */}
                <div className="hero-indicators">
                    {banners.map((_, i) => (
                        <span 
                            key={i} 
                            className={`indicator-dot ${i === bgIndex ? 'active' : ''}`}
                            onClick={() => setBgIndex(i)}
                        />
                    ))}
                </div>
            </div>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                {getInlineLoader()}
            </div>
        );
    }
}